module.exports = __webpack_public_path__ + "font/open-sans-regular.347639e.woff";